import { signal } from '@angular/core';
import type { Currency } from '@inshuwa-client/models';
import {
  CURRENCY_DISPLAY_STORAGE_KEY,
  CurrencyDisplay,
  currencySymbol,
  formatCurrency,
  resolveCurrencyDisplay,
} from './currency-display';

/**
 * A signal rather than a service, because the chart formatters that need it are plain functions
 * handed to echarts with no injector in reach.
 */
export const currencyDisplay = signal<CurrencyDisplay>(
  resolveCurrencyDisplay(readStored()),
);

function readStored(): string | null {
  try {
    return localStorage.getItem(CURRENCY_DISPLAY_STORAGE_KEY);
  } catch {
    return null;
  }
}

export function setCurrencyDisplay(display: CurrencyDisplay): void {
  currencyDisplay.set(display);
  try {
    localStorage.setItem(CURRENCY_DISPLAY_STORAGE_KEY, display);
  } catch {
    // A blocked store only costs the preference for this session.
  }
}

export function formatMoneyValue(
  value: number | string | null | undefined,
  currency: Currency | string | null | undefined,
  digitsInfo?: string,
): string {
  return formatCurrency(value, currency, currencyDisplay(), digitsInfo);
}

export function activeCurrencySymbol(currency: Currency = 'ZMW'): string {
  return currencySymbol(currency, currencyDisplay());
}
